<!-- 资源管理菜单项的 投放书籍- -->
<template>
<div id="book">
	<!-- 标题 -->
	<div :style="{'width': table_scroll_width + 'px'}" style="position: relative;">
		<div class="page-title"  style="position: sticky;left: 30px;z-index: 5;width: 300px;">推广作品管理</div>
		
		<div style="display: flex;justify-content: space-between;align-items: center;margin-top: 10px;margin-bottom: 15px;padding-right: 17px;">
			<div style="display: flex;align-items: center;">
				<div v-for="(item,index) in titleTab" :key="index" 
				:class="{'title-tab-box-selected': item.select}" 
				@click="changeTab(item,index)"
				class="title-tab-box">{{item.label}}</div>
			</div>
			
			<div @click="goRoute" class="title-tab-box title-tab-box-selected" style="margin-left: 35px;padding: 6px 15px;">作品分类管理</div>
		</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;">
			
			<div class="screen-box" style="margin-bottom: 0;">
				<div class="screen-label">作品名称</div>
				<a-input v-model="r_book_name" allowClear placeholder="请输入" style="width: 240px;"/>
			</div>
			
			<div class="screen-box" style="margin-bottom: 0;">
				<div class="screen-label">渠道</div>
					
				<!-- <a-select :value="r_channel_id"
				 style="width: 240px" 
				 placeholder="未选择" 
				 @change="handleChangeC" 
				 :filter-option="filterOption" 
				 showSearch
				 >
					<a-select-option  v-for="(item,index) in filterData.channel_id.list" :key="item.key" :value="item.key">
						{{item.value}}
					</a-select-option>
				</a-select> -->
				
				<!-- <a-select
					style="width: 240px"
					placeholder="请选择渠道"
					@change="handleChangeC"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(value,key) in xsChannelSelect" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select> -->
				<a-select v-if="content_type == 2"
					style="min-width: 220px;max-width: 450px;"
					placeholder="请选择渠道"
					@change="handleChangeC"
					:value="r_channel_id"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(value,key) in filterData.vd_channel.list" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
				
				<!-- <a-select v-else-if="content_type == 1"
					style="min-width: 220px;max-width: 450px;"
					placeholder="请选择渠道"
					@change="handleChangeC"
					:value="r_channel_id"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(value,key) in filterData.mp_book_channel.list" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select> -->
				<a-select v-else-if="content_type == 1"
					style="min-width: 220px;max-width: 450px;"
					placeholder="请选择渠道"
					@change="handleChangeC"
					:value="r_channel_id"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(value,key) in xsChannelSelect" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box" style="margin-bottom: 0;">
				<div class="screen-label">频道</div>
				<a-select style="width: 160px;" placeholder="请选择" :value="r_book_type" allowClear
				 @change="handleChangeA" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="0">待选择</a-select-option>
					<a-select-option value="1">男频</a-select-option>
					<a-select-option value="2">女频</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box" style="margin-bottom: 0;">
				<div class="screen-label">分类</div>
				
				<a-select
					style="width: 180px"
					placeholder="请选择作品分类"
					@change="handleChangeZ"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(item,index) in filterData.book_category.list" :key="item.key" :value="item.key" :title="item.value">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
			<!-- <a-button @click="exportButton" type="primary" icon="download"  style="margin-right: 20px;">导出</a-button> -->
			<a-button @click="addButton" style="background-color: #67c23a;border-color: #67c23a;" icon="plus" type="primary">新建推广作品</a-button>
		</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':rableTitle[0].width + 'px'}" 
				@click="sortClick(0)">
					ID
					<div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': rableTitle[0].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': rableTitle[0].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
				<div class="table-th-cell" style="cursor: default;"
				:style="{'width':rableTitle[1].width + 'px'}" 
				@click="sortClick(1)">
					作品名称
				</div>
				
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
			
				<div v-if="(item.type !== 'id' && item.type !== 'book_name')" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			<!-- 占位，隔出一个空白区域 -->
			<div id="" style="padding:15px;"></div>
		</div>
		
		
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				
					<div  class="table-td-cell"
					:style="{'width':rableTitle[0].width + 'px'}">
						{{item.id}}
					</div>
					<div  class="table-td-cell"
					:style="{'width':rableTitle[1].width + 'px'}">
						{{item.book_name}}
					</div>
				
			</div>
			<!-- 产品类型 -->
			<div class="table-td-cell" :style="{'width': rableTitle[2].width + 'px'}">
				{{item.product_type_name}}
			</div>
			<!-- 频道 -->
			<div class="table-td-cell" :style="{'width': rableTitle[3].width + 'px'}">
				{{item.type | bookTypeFilters}}
			</div>
			<!-- 分类 -->
			<div class="table-td-cell" :style="{'width': rableTitle[4].width + 'px'}">
				{{item.category}}
			</div>
			<!-- 渠道 -->
			<div class="table-td-cell" :style="{'width': rableTitle[5].width + 'px'}">
				{{item.book_channel}}
			</div>
			<!-- 首日ROI目标(%) -->
			<div class="table-td-cell" :style="{'width': rableTitle[6].width + 'px'}" >
				{{item.return_require}}
			</div>
			<!-- 备注 -->
			<div class="table-td-cell" :style="{'width': rableTitle[7].width + 'px'}" >
				{{item.remark}}
			</div>
			<!-- 操作 -->
			<div @click="editTable(index)" class="table-td-cell" :style="{'width': rableTitle[8].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
				编辑
			</div>
			
		</div>
		
		
		<div v-show="tableShowData.length === 0" :style="{'width': table_scroll_width + 'px',}" style="text-align: center;padding: 80px 0 50px;">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
	</div>
	
	<!-- 分页 -->
	<!-- <div :style="{'width': table_scroll_width + 'px',}"> -->
		<!-- <div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': table_scroll_width + 'px',}">
			<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" />
		</div> -->
	<!-- </div> -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="body_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	<!-- 新增的侧边栏 -->
	<a-drawer
	  :title="`${drawer_title}推广作品`"
	  width="600px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">作品名称</div>
					
				<a-input v-model="x_book_name" placeholder="请输入" style="width: 340px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">产品类型</div>
					
				<a-radio-group v-model="x_product_type" @change="radioChangeA">
				    <a-radio :value="1">
				        小说
				    </a-radio>
				    <a-radio :value="2">
				        短剧
				    </a-radio>
				</a-radio-group>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">频道</div>
					
				<a-select :value="x_book_type" style="width: 340px" placeholder="未选择"
				 @change="handleChangek" >
					<!-- <a-select-option value="0">待选择</a-select-option> -->
					<a-select-option value="1">男频</a-select-option>
					<a-select-option value="2">女频</a-select-option>
				</a-select>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">分类</div>
					
				<a-select :value="x_category" 
				 style="width: 340px" 
				 placeholder="未选择" 
				 @change="handleChangeL" 
				 :filter-option="filterOption" 
				 showSearch
				 notFoundContent="请先选择分类" 
				 >
					<!-- <a-select-option value="0">待选择</a-select-option> -->
					<a-select-option  v-for="(item,index) in categoryShowList" :key="item.id" :value="item.id">
						{{item.category}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">渠道</div>
					
				<a-select v-if="content_type == 2" 
				:value="x_channel_id"
				 style="width: 340px" 
				 placeholder="未选择" 
				 @change="handleChangeF" 
				 :filter-option="filterOption" 
				 showSearch
				 >
					<a-select-option v-for="(value,key) in filterData.vd_channel.list" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
				<a-select v-else-if="content_type == 1" 
				:value="x_channel_id"
				 style="width: 340px" 
				 placeholder="未选择" 
				 @change="handleChangeF" 
				 :filter-option="filterOption" 
				 showSearch
				 >
					<a-select-option v-for="(value,key) in xsChannelSelect" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">首日ROI目标(%)</div>
					
				<a-input v-model="x_roi" placeholder="请输入" type="number" style="width: 340px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">备注</div>
					
				<a-textarea
					style="width: 340px;"
				    placeholder="请输入内容"
				    :auto-size="{ minRows: 5, maxRows: 10 }"
					v-model="x_remark"
				/>
			</div>
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>

	</a-drawer>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { bookPutList, bookCategoryList, addBook, editBook, bookInfo, bookExport, putDataMenu } from '@/request/api'
export default {
	name: 'putBook_',
	components: {
	},
	data() {
		return {
			table_scroll_width: 2600,
			
			r_book_name: "", // 书籍名字
			r_book_type: undefined, // 频道，男频/女频
			r_limit: 50,
			r_page: 1,
			r_sort_field: "",
			r_sort_type: "",
			r_product_type: 1, // 产品类型：1=小说，2=短剧
			r_book_category: undefined, // 作品分类
			r_channel_id: undefined, // 渠道
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID",width:100, sort_status:0, type:"id", text_right: false,sort_:90,sort_control: true,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"作品名称",width:220, sort_status:0, type:"book_name", text_right: false,sort_:89,sort_control: false,},
				{title:"产品类型",width:120, sort_status:0, type:"product_type_name", text_right: false,sort_:89,sort_control: false,},
				{title:"频道",width:120, sort_status:0, type:"type", text_right: false,sort_:88,sort_control: false,},
				{title:"分类",width:150, sort_status:0, type:"category", text_right: false,sort_:87,sort_control: false,},
				{title:"渠道",width:120, sort_status:0, type:"book_channel", text_right: false,sort_:89,sort_control: false,},
				{title:"首日ROI目标(%)",width:120, sort_status:0, type:"first_day_roi_format", text_right: false,sort_:86,sort_control: false,},
				{title:"备注",width:180, sort_status:0, type:"remark", text_right: false,sort_:86,sort_control: false,},
				{title:"操作",width:100, sort_status:0, type:"cz", text_right: false,sort_:85,sort_control: false,},
			],
			tableShowData: [],
			
			search_button_loading: false, // 搜索按钮的加载状态
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			
			visible: false,
			// 新增侧边栏
			x_book_name: "", // 作品名称
			x_roi: "", // 首日ROI目标(%)
			x_book_type: undefined, // 频道
			x_category: undefined, // 分类
			x_id: "", // id
			x_channel_id: undefined, // 渠道
			x_product_type: 1, // 产品类型：1=小说，2=短剧
			x_remark: null,
			
			add_form_hint: "", // 侧边栏新增表单的验证提示
			categoryManList: [], // 男频的分类选择
			categoryWomanList: [], // 女频的分类选择
			categoryShowList: [], // 分类的显示
			drawer_title: "", // 侧边栏标题
			table_total: 0, // 表格内容总数
			
			body_width: 1800, // body的宽度
			
			// 筛选条件部分
			filterData: {
				channel_id:{
					list: [{}],
				},
				book_category: {},
				vd_channel: {},
				mp_book_channel: {},
			}, // 筛选条件数组
			xsChannelSelect: [], // 小说小程序渠道+公众号渠道+快应用渠道
			
			titleTab: [
				{label: "小说作品", select: true , value: 1 },
				{label: "短剧作品", select: false , value: 2 },
			],
			content_type: 1, // 页面内容展现类型
		}
	},
	mounted(){
		let that = this
		// that.body_width = document.body.clientWidth - 60
		// console.log("that.body_width",that.body_width);
		
		// let nn = 0
		// that.rableTitle.forEach((res,index)=>{
		// 	nn = nn + res.width
		// })
		// that.table_scroll_width = nn + 30
		// console.log(that.table_scroll_width)
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		// that.table_null_width = table_info.null_width
		
		putDataMenu().then(res=>{
			console.log("获取搜索条件",res);
			that.filterData = res.data.data.filter
			
			let f_select = res.data.data.filter
			// console.log("f_select",f_select);
			that.xsChannelSelect = { ...f_select.gzh_channel.list, ...f_select.qk_channel_new.list, ...f_select.mp_book_channel.list }
			console.log("xsChannelSelect",that.xsChannelSelect)
		})
		
		that.searchButton()
		
		
		that.getCategorySelect()
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		
		// 频道
		handleChangeA(value){
			this.r_book_type = value
		},
		// 新增侧边栏-频道
		handleChangek(value){
			console.log(value)
			
			if(value == 1){
				this.categoryShowList = this.categoryManList
			}
			else if(value == 2){
				this.categoryShowList = this.categoryWomanList
			}
			else {
				this.categoryShowList = []
			}
			this.x_book_type = value
			this.x_category = undefined // 重置分类内容
		},
		// 新增侧边栏-分类
		handleChangeL(value){
			this.x_category = value
		},
		// 侧边栏-渠道选择
		handleChangeF(e){
			this.x_channel_id = e
		},
		// 作品分类
		handleChangeZ(e){
			console.log("作品分类",e);
			this.r_book_category = e
		},
		// 渠道
		handleChangeC(e){
			this.r_channel_id = e
		},
		// 获取分类
		getCategorySelect(){
			let that = this 
			bookCategoryList({
				product_type: that.r_product_type
			}).then(res=>{
				console.log("新增侧边栏的分类",res.data.data.data)
				let data = res.data.data.data
				let m_data = []
				let wom_data = []
				data.forEach(res=>{
					if(res.gender === "男频"){
						m_data.push(res)
					}
					else if(res.gender === "女频"){
						wom_data.push(res)
					}
				})
				that.categoryManList = m_data, // 男频的分类选择
				that.categoryWomanList = wom_data, // 女频的分类选择
				console.log("m_data",m_data)
				console.log("wom_data",wom_data)
			})
		},
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			if(type != '分页'){
				that.r_page = 1
			}
			
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				book_name: that.r_book_name,
				book_type: that.r_book_type,
				// sort_field: that.r_sort_field,
				// sort_type: that.r_sort_type
				
				channel_id: that.r_channel_id,
				product_type: that.r_product_type,
				category: that.r_book_category,
			}
			if(type != '导出'){
				bookPutList(r_data).then(res=>{
					console.log("搜索结果",res)
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.search_button_loading = false
						that.$message.success('搜索成功');
						
						that.table_total = res.data.data.total
						that.tableShowData = res.data.data.data || []
						
						// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
						setTimeout(()=>{
							document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						},100)
					}
					else {
						that.search_button_loading = false
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
					}
					
				}).catch(err=>{
					console.log(err)
					that.$message.error("搜索失败，可能是网络出现问题");
				})
			}
			else if(type == '导出'){
				r_data.export = 1
				delete r_data.page
				delete r_data.limit
				bookExport(r_data).then(res=>{
					console.log("导出测试",res);
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
						
						that.$message.success(res.data.msg || "导出成功");
						
					}
					else {
						
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
					}
				})
			}
		},
		// 导出
		exportButton(){
			let that = this
			
			
			that.searchButton('导出')
			// 
		},

		// 新增侧边的确认按钮
		addRequest(){
			let that = this
			if(!that.x_book_name){ // 作品名称
				that.add_form_hint = "请填写 作品名称 ！！！"
			}
			else if(!that.x_book_type){ // 频道
				that.add_form_hint = "请填写 频道 ！！！"
			}
			else if(!that.x_category){ // 分类
				that.add_form_hint = "请填写 分类 ！！！"
			}
			else if(!that.x_roi && that.x_roi != 0){ // 首日ROI目标(%)
				that.add_form_hint = "请填写 首日ROI目标(%) ！！！"
			}
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
				
				let r_data = {
					book_name: that.x_book_name,
					book_type: that.x_book_type,
					category: that.x_category,
					roi: that.x_roi,
					channel_id: that.x_channel_id || "0",
					
					product_type: that.x_product_type,
					remark: that.x_remark
				}
				if(that.drawer_title == "新增"){
					addBook(r_data).then(res=>{
						console.log("新增",res)
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
							that.$message.success('新增成功');
							that.add_button_loading = false
							// 关闭弹窗等一系列操作
							that.onCloseDrawer()
							// 重新搜索一边
							that.searchButton()
						}
						else {
							that.add_button_loading = false
							that.$message.error(res.data.msg || "新增失败");
						}
					})
				}
				else if(that.drawer_title == "编辑"){
					r_data.id = that.x_id
					// console.log(r_data)
					editBook(r_data).then(res=>{
						console.log("编辑",res)
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
							that.$message.success('编辑成功');
							that.add_button_loading = false
							// 关闭弹窗等一系列操作
							that.onCloseDrawer()
							// 重新搜索一边
							that.searchButton()
						}
						else {
							that.add_button_loading = false
							that.$message.error(res.data.msg || "编辑失败");
						}
					})
				}
				
				
			}
		},
		onCloseDrawer(){
			// if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
			// 	return
			// }
			this.visible = false
			this.categoryShowList = []
			this.x_book_name = "", // 作品名称
			this.x_roi = "", // 首日ROI目标(%)
			this.x_book_type = undefined, // 频道
			this.x_category = undefined // 分类
			this.x_channel_id = undefined // 渠道
			
			this.x_remark = null
			
			this.add_button_loading = false
		},
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			
			that.searchButton()
		},
		
		// 表格内的编辑
		editTdClick(index){
			let that = this
			// console.log("表格内的编辑",that.tableShowData[index])
			that.search_button_loading = true
			bookInfo({id: that.tableShowData[index].id}).then(res=>{
				that.search_button_loading = false
				console.log(res.data.data)
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					let data = res.data.data
					
					if(that.tableShowData[index].type == 1){
						that.categoryShowList = that.categoryManList
					}
					else if(that.tableShowData[index].type == 2){
						that.categoryShowList = that.categoryWomanList
					}
					else {
						that.categoryShowList = []
					}
					that.drawer_title = "编辑"
					
					// 从接口拿数据
					that.x_book_name = data.book_name, // 作品名称
					that.x_roi = data.return_require, // 首日ROI目标(%)
					that.x_book_type = data.type.toString(), // 频道
					that.x_category = data.category || undefined, // 分类
					that.x_id = data.id // 表格id
					
					let c_id = undefined
					if(data.channel_id){
						c_id = data.channel_id.toString()
					}
					that.x_channel_id = c_id // 渠道
					
					that.x_product_type = data.categorys.product_type
					that.x_remark = data.remark || ""
					
					that.visible = true
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
			
			
		},
		// 显示新增侧边栏
		addButton(){
			this.drawer_title = "新增"
			
			this.x_product_type = this.r_product_type
			
			this.visible = true
		},
		
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton('分页')
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				this.tableThClick(index, th_status, that.rableTitle[index].type)
				// this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		editTable(index){
			// this.$emit('edit-td-click', index)
			this.editTdClick(index)
		},
		changeTab(e,index){
			console.log(e);
			// 如果已经是选中状态就没必要再执行一次了
			if(!this.titleTab[index].select){ 
				console.log("e.value",e.value);
				this.content_type = e.value
				this.r_product_type = e.value
				
				this.titleTab.forEach(res=>{
					res.select = false
				})
				this.titleTab[index].select = true
				
				this.r_channel_id = undefined
				
				this.getCategorySelect()
				
				this.searchButton('button')
			}
			console.log(this.content_type)
		},
		radioChangeA(e){
			// this.x_product_type = e.target.value
			this.x_product_type = this.r_product_type
			console.log("单选",e);
		},
		goRoute(){
			const { href } = this.$router.resolve({ path:'/bookCategory', query:{}})
			
			window.open(href, '_blank');
		},
	},
	filters: {
		bookTypeFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value === 0){
				vvv = "未设置"
			}
			else if(value === 1){
				vvv = "男频"
			}
			else if(value === 2){
				vvv = "女频"
			}
			return vvv
		}
	}
}
</script>

<style scoped>
/* 用于子页面的样式 */
.title-tab-box {
	color: #313a46;
	padding: 8px 20px;
	border: 1px solid #ccc;
	cursor: pointer;
}

.title-tab-box-selected {
	color: #62a8ea;
	border: 1px solid #62a8ea;
}
</style>